module.exports = __webpack_public_path__ + "../static/img/base_aruba.23e66566.png";